import type {FC} from 'react';

import styled, {css} from 'styled-components';

import type {WithTestID} from '../../../../utils/utility-types';

import CalendarSvg from '../../../../assets/icons/primary/Calendar.svg';
import {ms} from '../../../../styles';
import {Button} from '../../../../uikit/Button';
import {Text} from '../../../../uikit/Text';
import {View} from '../../../../uikit/View';
import {platform} from '../../../../utils/platform';

const StyledButton = styled(Button.V2)<{isRounded: boolean}>`
  min-height: ${ms(64)};
  width: 100%;

  ${p =>
    p.isRounded &&
    platform.isWeb &&
    css`
      border-radius: ${ms(100)};
    `}
`;

const IconContainer = styled(View)``;

const TextContainer = styled(View)<{isCentred: boolean}>`
  flex-direction: column;
  align-items: ${p => (p.isCentred ? 'center' : 'flex-start')};
`;

const Layout = {
  Icon: IconContainer,
  Text: TextContainer,
};

interface Props extends WithTestID {
  detail: string;
  disabled: boolean;
  isLoading?: boolean;
  isRounded?: boolean;
  onClick: any;
  title: string;
  withIcon?: boolean;
}

export const BookButton: FC<Props> = ({
  detail,
  disabled,
  isLoading,
  isRounded = false,
  onClick,
  testID,
  title,
  withIcon = false,
}) => {
  return (
    <StyledButton
      disabled={disabled}
      iconLeft={withIcon ? CalendarSvg : undefined}
      isLoading={isLoading}
      isRounded={isRounded}
      onClick={onClick}
      scheme={'secondary'}
      testID={testID}
    >
      <Layout.Text isCentred={!withIcon}>
        <Text color={'text.white'} weight={'bold'}>
          {title}
        </Text>
        <Text color={'text.white'} variant={'label.la'}>
          {detail}
        </Text>
      </Layout.Text>
    </StyledButton>
  );
};
